module.exports = __webpack_public_path__ + "media/images/flags/UY-4f0941fee8daf68cf663e97dc89a7745.svg";